<template>
  <div class="custom-padding-bottom-10px">
    <a-spin
      :spinning="loading"
    >
      <div
        ref="packageTrendChart"
        style="height: 220px"
      />
    </a-spin>
  </div>
</template>

<script>
import { formatBigNumber } from '@/utils/filter'
import { findPackageStatisticsTrend } from '@/api/package_statistic'

export default {
  name: 'PackageTrendChart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    this.handleWindowResize = this.$lodash.throttle(this.handleWindowResize, 1000)
    return {
      chart: null,
      tagStatistics: {},
      loading: true
    }
  },
  created() {
    window.addEventListener('resize', this.handleWindowResize)
  },
  mounted() {
    this.fetchData()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  watch: {
    data(val) {
      this.fetchData()
    }
  },
  computed: {
    chartOption() {
      return {
        tooltip: {
          trigger: 'axis',
          position: (point, params, dom, rect, size) => {
            // size为当前窗口大小
            if ((size.viewSize[0] / 2) >= point[0]) {
              // 其中point为当前鼠标的位置
              return [point[0] + 20, '10%']
            } else {
              // 其中point为当前鼠标的位置
              return [point[0] - 200, '10%']
            }
          },
          formatter: (params) => {
            let relVal = params[0].name
            for (let i = 0; i < params.length; i++) {
              relVal += `<br/>${params[i].marker}
              <span style="width: 100px; overflow: hidden;text-overflow: ellipsis; display: inline-block; vertical-align: bottom">
              ${params[i].seriesName}
              </span>
              &nbsp;&nbsp;
              ${formatBigNumber(params[i].value)}`
            }
            return relVal
          }
        },
        legend: { data: [], type: 'scroll' },
        grid: { x: 30, y: 50, x2: 0, y2: 20 },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: []
      }
    }
  },
  methods: {
    handleWindowResize() {
      this.chart && this.chart.resize()
    },

    // 用于设置渐变色
    setSeries() {
      // 从全局色中获取一个颜色
      const seriesColor = this.chart._theme.color[0]
      this.chartOption.series.push({
        type: 'line',
        data: this.$lodash.map(this.tagStatistics.statistics, 'count'),
        name: this.tagStatistics.tag_name,
        color: seriesColor,
        areaStyle: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: seriesColor
            },
            {
              offset: 0.8,
              color: 'rgba(255, 255, 255, 0)'
            }
          ])
        }
      })
    },

    drawChart() {
      this.chart ||= this.$echarts.init(this.$refs.packageTrendChart, 'echarts_custom')
      this.chartOption.legend.data = this.$lodash.map(this.tagStatistics, 'tag_name')
      this.chartOption.xAxis.data = this.$lodash.map(this.tagStatistics.statistics, 'name')
      this.chartOption.series = []
      this.setSeries()
      this.chart.setOption(this.chartOption, true)
    },

    fetchData() {
      this.loading = true
      findPackageStatisticsTrend(this.data).then((res) => {
        if (res.code === 0) {
          this.tagStatistics = res.data
          this.drawChart()
        }
        this.loading = false
      })
    }
  }
}
</script>
